var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showChristmasTree)?_c('v-icon',_vm._b({},'v-icon',_vm.$attrs,false),[_vm._v("$christmasTree")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }